export default __webpack_public_path__ + "static/media/gamming_keyboard.57c67acf.jpg";